import React from 'react';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import { variant } from 'styled-system';

import DividerHorizontal from './DividerHorizontal';
import { DividerVerticalProps } from './types';

const StyledDividerVertical = styled(DividerHorizontal, {
  shouldForwardProp: (prop) => isPropValid(prop),
})<DividerVerticalProps>(
  css({
    width: '0px',
    height: '100%',
    borderWidth: 0,
  }),
  variant({
    prop: 'type',
    variants: {
      solid: {
        borderLeftWidth: 1,
      },
      dashed: {
        borderLeftWidth: 1,
      },
      thick: {
        width: '3px',
      },
    },
  })
);

const DividerVertical = (props) => (
  <StyledDividerVertical {...props} aria-orientation="vertical" />
);

export default DividerVertical;
